The application question information of the suggestion.

This will be a SEEK library question suitable for use in an application questionnaire.
